import { render } from "./VerifyWebhook.vue?vue&type=template&id=a2c0b8ec"
import script from "./VerifyWebhook.vue?vue&type=script&lang=js"
export * from "./VerifyWebhook.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__